<template>
    <div>
        <ValidationObserver tag="form" ref="observer" @submit.prevent="onSubmit">
            <FormLesiones :form="form"/>

            <div class="row mx-md-n5">
                <div class="col px-md-5 text-right">
                    <b-button type="submit">Confirmar</b-button>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import FormLesiones from './FormLesiones.vue';

    export default {
        props: [
            'base_id',
            'lesion'
        ],
        data() {
            return {
                form: {
                    fecha_baja: this.lesion.fecha_baja,
                    orientacion_diagnostica: this.lesion.orientacion_diagnostica,
                    fecha_alta: this.lesion.fecha_alta,
                },
            }
        },
        methods: {
            async onSubmit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {     
                    this.form.filters = {};
                    this.form.base_id = this.base_id;
                    this.form.lesion_id = this.lesion.id;
                    this.form.lista_id = this.lista_id;
            
                    this.$store.dispatch(this.config.getVuexAlias('back.bases.lesiones.update'), this.form).then(() => {
                        this.$toast.success('Lesión editada correctamente.');
                        this.$emit('editarLesion');
                    }).catch(e => {
                        this.$toast.error('An error occurred.');
                    });
                }
            },
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            }
        },
        created() {
            if(this.lesion) {
                this.form.fecha_baja = this.lesion.fecha_baja;
                this.form.orientacion_diagnostica = this.lesion.orientacion_diagnostica;
                this.form.fecha_alta = this.lesion.fecha_alta;
            }
        },
        components: {
            FormLesiones
        }
    }
</script>